import Box from '@redbubble/design-system/src/Box';
import Text from '@redbubble/design-system/src/Text';
import React, { useEffect, useState } from 'react';
import { Colon } from '../Colon/Colon';
import styles from './CountdownTimer.module.scss';

interface CountdownTimerProps {
  secondsLeft: number;
}
interface TimeLeft {
  hours: string;
  minutes: string;
  seconds: string;
}

const getTimeLeft = (totalSeconds: number): TimeLeft => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return {
    hours: hours.toString().padStart(2, '0'),
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
  };
};

export const CountdownTimer: React.FC<CountdownTimerProps> = ({
  secondsLeft,
}) => {
  const [seconds, setSeconds] = useState(secondsLeft);

  // biome-ignore lint/correctness/useExhaustiveDependencies: useExhaustiveDependencies
  useEffect(() => {
    if (seconds <= 0) return;
    const intervalId = setInterval(() => {
      setSeconds((prevSeconds) => Math.max(prevSeconds - 1, 0));
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);

  const timeLeft = getTimeLeft(seconds);

  return (
    <Box className={styles.countdownTimer} data-testid="countdown-timer">
      <Box className={styles.timeContainer}>
        <Text className={styles.timeLeft} type="display5">
          {timeLeft.hours}
        </Text>
        <Text className={styles.timeUnit} type="display6">
          H
        </Text>
      </Box>

      <Colon />

      <Box className={styles.timeContainer}>
        <Text className={styles.timeLeft} type="display5">
          {timeLeft.minutes}
        </Text>
        <Text className={styles.timeUnit} type="display6">
          M
        </Text>
      </Box>

      <Colon />

      <Box className={styles.timeContainer}>
        <Text className={styles.timeLeft} type="display5">
          {timeLeft.seconds}
        </Text>
        <Text className={styles.timeUnit} type="display6">
          S
        </Text>
      </Box>
    </Box>
  );
};
